import template from './workTeamCard.html';
import controller from './workTeamCard.controller';
import './workTeamCard.scss';

let workTeamCardComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    employee: '<',
    
  },
  template,
  controller
};

export default workTeamCardComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/workTeamList/workTeamCard/workTeamCard.component.js